module.exports = __webpack_public_path__ + "img/flag-mt.85b38b92.png";